import React from 'react';
import PropTypes from 'prop-types';
import InfoBox from 'components/widget/InfoBox';
import TextLink from 'components/TextLink';
import styled from 'styled-components';

const Wrapper = styled(InfoBox)`
  .TextLink {
    margin: -0.5em 0;
    display: inline-block;
    padding: 0.5em 0;
  }
`;

const Component = ({ storeUrl }) => (
  <Wrapper>
    We&apos;re sorry but the option to skip a delivery is not available right
    now. This may be because you&apos;ve already skipped a certain number of
    times. Please call us or visit&nbsp;
    <TextLink component="a" props={{ href: storeUrl, target: '_blank' }}>
      your store
    </TextLink>
    &nbsp;where a colleague will be happy to help you
  </Wrapper>
);

Component.propTypes = {
  storeUrl: PropTypes.string.isRequired,
};
export default Component;
